import React from 'react';

import { SimpleItineraryCardRow } from '@travelpassero/khaos';
import { useDrag } from 'react-dnd';
import { ItemTypes } from '@utils/dragTypes';

function SimpleItineraryCardDnDContainer({
  idea,
  isNoteOpened,
  itineraryNote,
  isSplitScreen,
  cardBackgroundColor,
  onNoteClick,
  onEditClick,
  onTextAreaChange,
  hasSavedText,
  onTimeChange,
  onDragCard,
  ...args
}) {
  const { id } = idea;
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.ITINERARYCARD,
    item: { id, type: ItemTypes.ITINERARYCARD },
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult) {
        onDragCard(id, dropResult.name);
      }
      return null;
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  if (isDragging) {
    return <div ref={drag} />;
  }

  return (
    <div ref={drag}>
      <SimpleItineraryCardRow
        ref={drag}
        idea={idea}
        isNarrow={isSplitScreen}
        isSplitScreen={isSplitScreen}
        cardBackgroundColor={cardBackgroundColor}
        onNoteClick={onNoteClick}
        onEditClick={onEditClick}
        onTextAreaChange={onTextAreaChange}
        hasSavedText={hasSavedText}
        onTimeChange={onTimeChange}
        hasNoteTextBox={!isSplitScreen}
        {...args}
      />
    </div>
  );
}

export default SimpleItineraryCardDnDContainer;
